var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('router-view'),_c('privacy-alert-app'),_c('loader-dialog-app'),_c('alert-app'),_c('dialog-pwa')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }